import React from 'react'
import { useAtomValue } from 'jotai'

import { Access } from '../../lib'
import * as state from '../../states'
import { TRevenueAgencyHistory, ERevenueAgencyFakeType } from '../../types'
import { IUiTableConfig, UiTable, UiDateInfo, CheckBoxStatusIcon } from '../ui'
import { REVENUE_AGENCY_FAKE_TYPE_COLORS_MAP } from '../../constants'
import { RevenueAgencyFakeTypeField } from './RevenueAgencyListTable'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueAgencyHistoryListTableProps = {
	items: Array<TRevenueAgencyHistory>;
	skip: number;
}

export const RevenueAgencyHistoryListTable = (props: IRevenueAgencyHistoryListTableProps) => {
	const {
		items = [],
		skip = 0
	} = props
	const { t } = useTranslation()
	const profile = useAtomValue(state.profileAtom)
	const $access = new Access(profile ?? null)

	const revenueAgencyListTableConfig: IUiTableConfig<TRevenueAgencyHistory>[] = [
		{
			key: 'name',
			title: t(ALL_LANG_KEY.revenue_agency_list_table.column_name)
		},
		{
			key: 'updatedAt',
			title: t(ALL_LANG_KEY.revenue_agency_list_table.column_date_updated),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value}/>
				)
			}
		},
		{
			key: 'isSystem',
			title: t(ALL_LANG_KEY.revenue_agency_list_table.column_is_system),
			classesToAdd: {
				th: 'text-center',
				td: 'text-center'
			},
			rowCellFormatter: ({ value, rowData }) => {
				return <>
					<CheckBoxStatusIcon value={rowData.isSystem} iconCheckColor={'--dangerColor'}/>
				</>
			}
		},
		{
			key: 'isActive',
			title: t(ALL_LANG_KEY.revenue_agency_list_table.column_is_active),
			classesToAdd: {
				th: 'text-center',
				td: 'text-center'
			},
			rowCellFormatter: ({ value, rowData }) => {
				return <>
					<CheckBoxStatusIcon value={rowData.isActive}/>
				</>
			}
		},
		{
			key: 'isHold',
			title: t(ALL_LANG_KEY.revenue_agency_list_table.column_is_hold),
			classesToAdd: {
				th: 'text-center',
				td: 'text-center'
			},
			rowCellFormatter: ({ value, rowData }) => {
				return <>
					<CheckBoxStatusIcon value={rowData.isHold} iconCheckColor={'--warningColor'}/>
				</>
			}
		},
		{
			key: 'fakeType',
			title: t(ALL_LANG_KEY.revenue_agency_list_table.column_fake_type),
			classesToAdd: {
				th: 'text-center',
				td: 'text-center'
			},
			rowCellFormatter: ({ value, rowData, rowIndex, cellIndex }) => {
				const valueFormat: ERevenueAgencyFakeType = value ?? ERevenueAgencyFakeType.None

				return <div title={valueFormat}>
					<RevenueAgencyFakeTypeField
						value={value}
						rowData={rowData}
						classNamesToAdd={REVENUE_AGENCY_FAKE_TYPE_COLORS_MAP?.[valueFormat]}
						onClick={(rowData, e) => {
							console.log('Click on RevenueAgencyFakeType field :::', { value, rowData, rowIndex, cellIndex })
						}}
					/>
				</div>
			}
		}
	]

	return <>
		<UiTable
			data={items}
			config={revenueAgencyListTableConfig}
			// TODO: uncomment if necessary
			// classesToAdd={{
			// 	wrapper: 'table-sticky-wrapper table-sticky-wrapper--top-60',
			// }}
		/>
	</>
}